import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EventEmitter, inject, Injectable, Output } from '@angular/core';
import { OnsetExamResultDto } from '../../dtos/onset-exam-result-dto';
import { OnsetUserDto } from '../../dtos/onset-user-dto';
import { UrlService } from '../common/url.service';


@Injectable({
    providedIn: 'root',
})
export class IdasService {
    @Output() getOnsetExamDataCompleted: EventEmitter<OnsetUserDto> = new EventEmitter<OnsetUserDto>();
    @Output() postOnsetExamResultCompleted: EventEmitter<OnsetExamResultDto> = new EventEmitter<OnsetExamResultDto>();

    readonly #httpClient = inject(HttpClient);
    readonly #urlService = inject(UrlService);

    getOnsetExamData(token: string) {
        this.#httpClient
            .get<OnsetUserDto>(this.#urlService.authServiceUrl() + 'idas' + '/' + 'onset' + '/' + token)
            .subscribe((res: OnsetUserDto) => { this.getOnsetExamDataCompleted.emit(res); },
                (err: HttpErrorResponse) => {
                    console.log(err.error);
                    console.log(err.name);
                    console.log(err.message);
                    console.log(err.status);
                    this.getOnsetExamDataCompleted.emit(undefined);
                });
    }

    postOnsetExamResult(token: string, onsetExamResultDto: OnsetExamResultDto) {
        // TODO send result to backend
        this.#httpClient
            .post<OnsetExamResultDto>(this.#urlService.authServiceUrl() + 'idas' + '/' + 'onset' + '/' + token + '/' + 'results', onsetExamResultDto)
            .subscribe((res: OnsetExamResultDto) => { this.postOnsetExamResultCompleted.emit(res); },
                (err: HttpErrorResponse) => {
                    console.log(err.error);
                    console.log(err.name);
                    console.log(err.message);
                    console.log(err.status);
                });
    }
}

